<template>
  <div>
    <v-col cols="12">
      <v-card
        v-if="user().role === 'super_curator' || user().role === 'developer'"
        class="mb-2"
      >
        <v-card-text v-if="systemMessages">
          <v-card-title
            id="system-messages"
            class="bg-green text-white d-flex align-center"
          >
            SYSTEM MESSAGES
            <v-btn class="bg-info ml-5" @click.stop="showAddMessage()">
              <v-icon class="mr-1" color="white" icon="fas fa-plus" />
              <span class="text-white">Add message</span>
            </v-btn>
            <v-spacer />
          </v-card-title>

          <v-data-table
            :headers="headerItems"
            :items="systemMessages"
            :items-per-page-options="[5, 10, 20, 25, 30]"
            :loading="loading"
          >
            <template v-if="systemMessages" #item="{ item }">
              <tr>
                <td>
                  {{ item.id }}
                </td>
                <td>
                  <v-menu
                    :close-on-content-click="false"
                    location="bottom"
                    min-width="400"
                  >
                    <template #activator="{ props: menuProps }">
                      <span
                        style="cursor: pointer; border-bottom: 1px dashed grey"
                        v-bind="menuProps"
                      >
                        {{ item.message || "Click to edit..." }}
                      </span>
                    </template>
                    <template #default="{ isActive }">
                      <v-card class="pa-2">
                        <v-card-title class="mt-2 text-h6">
                          Update Message
                        </v-card-title>
                        <v-card-text class="pt-2">
                          <v-textarea
                            v-model="item.message"
                            hide-details
                            label="Edit away!"
                            variant="filled"
                          />
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="primary"
                            variant="text"
                            @click="
                              saveEditedMessage(item.id, item.message);
                              isActive.value = false;
                            "
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-menu>
                </td>
                <td>
                  {{ item.created_at }}
                </td>
                <td>
                  {{ item.updated_at }}
                </td>
                <td>
                  <v-icon
                    color="red"
                    end
                    icon="fas fa-trash"
                    size="small"
                    @click="deleteMessage(item.id)"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <v-row>
      <v-dialog v-model="dialogs.addMessage" max-width="700px">
        <v-card>
          <v-card-title class="text-h5"> Add new message</v-card-title>
          <v-card-text>
            <v-textarea
              v-model="dialogs.newMessage"
              clearable
              label="New message"
              name="new-message-field"
              placeholder="Type a message here..."
              regular
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red-darken-1"
              variant="elevated"
              @click="closeAddMessageMenu()"
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="!dialogs.newMessage"
              color="blue-darken-1"
              variant="elevated"
              @click="addMessage()"
            >
              OK
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogs.deleteMessage" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            Are you sure you want to
            <span style="color: red; padding-left: 5px; padding-right: 5px">
              DELETE
            </span>
            this message?
            <ul style="list-style-type: none">
              <li>ID: {{ dialogs.messageId }}</li>
            </ul>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red-darken-1"
              variant="elevated"
              @click="closeDeleteMessageMenu()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue-darken-1"
              variant="elevated"
              @click="confirmDeleteMessage()"
            >
              OK
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

import RestClient from "@/lib/Client/RESTClient";
import GraphClient from "@/lib/GraphClient/GraphClient";
import getMessages from "@/lib/GraphClient/queries/getMessages.json";
// import store from "@/store";
import formatDate from "@/utils/generalUtils";

const restClient = new RestClient();
const client = new GraphClient();

export default {
  name: "SystemMessages",
  mixins: [formatDate],
  props: {
    headerItems: {
      type: Array,
      default: null,
    },
  },
  data: () => {
    return {
      systemMessages: [],
      loading: false,
      dialogs: {
        id: null,
        message: null,
        addMessage: false,
        deleteMessage: false,
        newMessage: null,
        messageId: null,
      },
      error: {
        general: null,
      },
    };
  },
  computed: {
    ...mapState("users", ["user", "messages"]),
  },

  async mounted() {
    this.loading = true;
    client.setHeader(this.user().credentials.token);
    //Fetching hidden records
    let messages = await client.executeQuery(getMessages);
    this.prepareSystemMessages(messages);
    this.loading = false;
  },
  methods: {
    /**
     * Method to fetch messages from system
     * @param dataCuration
     */
    prepareSystemMessages(dataCuration) {
      if (
        Array.isArray(dataCuration.messages) &&
        dataCuration.messages.length
      ) {
        dataCuration.messages.forEach((item) => {
          this.systemMessages.push({
            id: item.id,
            message: item.message,
            created_at: this.formatDate(item.createdAt),
            updated_at: this.formatDate(item.updatedAt),
          });
        });
      }
    },

    showAddMessage() {
      const _module = this;
      _module.dialogs.addMessage = true;
    },

    async saveEditedMessage(id, message) {
      let _module = this;
      let data = {
        id: id,
        message: message,
      };
      let response = await restClient.updateMessage(
        data,
        this.user().credentials.token,
      );
      if (response.error) {
        _module.error.general = response.error;
      } else {
        _module.systemMessages.forEach(function (m) {
          if (m.id === id) {
            m.message = message;
          }
        });
        await this.$store.dispatch("messages/setMessages");
      }
    },

    deleteMessage(messageId) {
      const _module = this;
      _module.dialogs.messageId = messageId;
      _module.dialogs.deleteMessage = true;
    },

    closeAddMessageMenu() {
      const _module = this;
      _module.dialogs.addMessage = false;
    },

    async addMessage() {
      const _module = this;
      let data = {
        message: _module.dialogs.newMessage,
      };
      let response = await restClient.createMessage(
        data,
        this.user().credentials.token,
      );
      if (response.error) {
        _module.error.general = response.error;
      } else {
        _module.systemMessages.push({
          id: response.id,
          message: response.message,
          created_at: this.formatDate(response.created_at),
          updated_at: this.formatDate(response.updated_at),
        });
        await store.dispatch("messages/setMessages");
      }
      _module.dialogs.addMessage = false;
      _module.dialogs.newMessage = null;
    },

    closeDeleteMessageMenu() {
      const _module = this;
      _module.dialogs.messageId = null;
      _module.dialogs.deleteMessage = false;
    },

    async confirmDeleteMessage() {
      const _module = this;
      let response = await restClient.deleteMessage(
        _module.dialogs.messageId,
        this.user().credentials.token,
      );
      if (response.error) {
        _module.error.general = response.error;
      } else {
        let filtered = _module.systemMessages.filter(function (f) {
          return f.id !== _module.dialogs.messageId;
        });
        _module.systemMessages = filtered;
        await store.dispatch("messages/setMessages");
      }
      _module.dialogs.deleteMessage = false;
      _module.dialogs.messageId = null;
    },
  },
};
</script>

<style scoped>
:deep(.v-data-table-header tr th) {
  white-space: nowrap;
}
</style>
